/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_create_invitation_message_placeholder = /** @type {(inputs: { org_name: NonNullable<unknown> }) => string} */ (i) => {
	return `¡Bienvenida a ${i.org_name}!`
};

const en_persons_create_invitation_message_placeholder = /** @type {(inputs: { org_name: NonNullable<unknown> }) => string} */ (i) => {
	return `Welcome to ${i.org_name}!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ org_name: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_create_invitation_message_placeholder = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_create_invitation_message_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_create_invitation_message_placeholder", locale)
	if (locale === "es") return es_persons_create_invitation_message_placeholder(inputs)
	return en_persons_create_invitation_message_placeholder(inputs)
};
export { persons_create_invitation_message_placeholder as "persons.create_invitation.message_placeholder" }